import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Long: { input: any; output: any; }
};

export type GAgentEntity = {
  __typename?: 'AgentEntity';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export enum GAppEventType {
  ConversationAgentComment = 'CONVERSATION_AGENT_COMMENT',
  ConversationAgentMessage = 'CONVERSATION_AGENT_MESSAGE',
  ConversationArchived = 'CONVERSATION_ARCHIVED',
  ConversationAssigned = 'CONVERSATION_ASSIGNED',
  ConversationBotAssistantDisconnected = 'CONVERSATION_BOT_ASSISTANT_DISCONNECTED',
  ConversationBotAssistantReplying = 'CONVERSATION_BOT_ASSISTANT_REPLYING',
  ConversationBotAssistantSuggesting = 'CONVERSATION_BOT_ASSISTANT_SUGGESTING',
  ConversationBotMessage = 'CONVERSATION_BOT_MESSAGE',
  ConversationBotSuggestion = 'CONVERSATION_BOT_SUGGESTION',
  ConversationChatEnded = 'CONVERSATION_CHAT_ENDED',
  ConversationContactMessage = 'CONVERSATION_CONTACT_MESSAGE',
  ConversationCreated = 'CONVERSATION_CREATED',
  ConversationSnoozed = 'CONVERSATION_SNOOZED',
  ConversationSnoozeExpired = 'CONVERSATION_SNOOZE_EXPIRED',
  ConversationTagsChanged = 'CONVERSATION_TAGS_CHANGED',
  ConversationTransferred = 'CONVERSATION_TRANSFERRED',
  ConversationUnArchived = 'CONVERSATION_UN_ARCHIVED',
  ConversationUnSnoozed = 'CONVERSATION_UN_SNOOZED'
}

export type GBaseConnectedServiceEntity = {
  __typename?: 'BaseConnectedServiceEntity';
  capabilities: Array<GConnectedServiceCapabilityItem>;
  id: Scalars['String']['output'];
  type: GConnectedServiceItem;
};

export enum GChatPreChatSurveyFieldTargetEntityType {
  Contact = 'CONTACT',
  Conversation = 'CONVERSATION',
  Unknown = 'UNKNOWN'
}

export enum GChatPreChatSurveyFieldType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Dropdown = 'DROPDOWN',
  Email = 'EMAIL',
  MultilineText = 'MULTILINE_TEXT',
  Name = 'NAME',
  Number = 'NUMBER',
  PhoneNumber = 'PHONE_NUMBER',
  Radio = 'RADIO',
  Text = 'TEXT',
  Unknown = 'UNKNOWN'
}

export enum GConnectedServiceCapabilityItem {
  Email = 'EMAIL',
  EmbeddedChat = 'EMBEDDED_CHAT',
  FacebookMessenger = 'FACEBOOK_MESSENGER',
  Sms = 'SMS',
  WhatsApp = 'WHATS_APP'
}

export type GConnectedServiceChatEntity = {
  __typename?: 'ConnectedServiceChatEntity';
  behaviour: GWidgetConfigurationBehaviour;
  conversationSettings: GWidgetConfigurationConversation;
  iframeSettings: GWidgetConfigurationIframe;
  locale: GLocaleItem;
  preChatSurveyFields?: Maybe<Array<GWidgetConfigurationPreChatSurveyField>>;
  text: GWidgetConfigurationText;
  theme: GWidgetConfigurationTheme;
};

export enum GConnectedServiceChatEntityConversationStartModeItem {
  StartOnFirstContactMessage = 'START_ON_FIRST_CONTACT_MESSAGE',
  StartOnSurveySubmission = 'START_ON_SURVEY_SUBMISSION'
}

export enum GConnectedServiceChatEntityOperationModeItem {
  AgentsAlwaysAvailable = 'AGENTS_ALWAYS_AVAILABLE',
  AgentsOnShift = 'AGENTS_ON_SHIFT'
}

export enum GConnectedServiceItem {
  Chat = 'CHAT',
  ChatV2 = 'CHAT_V2',
  Email = 'EMAIL',
  Messenger = 'MESSENGER',
  None = 'NONE',
  SmsSubnumber = 'SMS_SUBNUMBER',
  Vonage = 'VONAGE'
}

export type GConnectedServiceNotFoundError = GUserError & {
  __typename?: 'ConnectedServiceNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String']['output'];
};

export type GContactAddressEntity = {
  __typename?: 'ContactAddressEntity';
  address: Scalars['String']['output'];
  addressType: GContactAddressTypeItem;
};

export enum GContactAddressTypeItem {
  ChatChannelId = 'CHAT_CHANNEL_ID',
  ChatVisitorId = 'CHAT_VISITOR_ID',
  EmailAddress = 'EMAIL_ADDRESS',
  FacebookUserId = 'FACEBOOK_USER_ID',
  PhoneNumber = 'PHONE_NUMBER',
  Unknown = 'UNKNOWN'
}

export type GContactNotFoundError = GUserError & {
  __typename?: 'ContactNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String']['output'];
};

export type GContactStoppedTypingInConversationInput = {
  contact: Scalars['String']['input'];
  conversation: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type GContactStoppedTypingInConversationPayload = {
  __typename?: 'ContactStoppedTypingInConversationPayload';
  success: Scalars['Boolean']['output'];
};

export type GContactTypingInConversationInput = {
  contact: Scalars['String']['input'];
  content: Scalars['String']['input'];
  conversation: Scalars['String']['input'];
  isFullContent: Scalars['Boolean']['input'];
  sequence: Scalars['Int']['input'];
  tenant: Scalars['String']['input'];
};

export type GContactTypingInConversationPayload = {
  __typename?: 'ContactTypingInConversationPayload';
  success: Scalars['Boolean']['output'];
};

export type GConversationAgentMessage = {
  __typename?: 'ConversationAgentMessage';
  agent?: Maybe<GAgentEntity>;
  attachments: Array<GConversationAttachment>;
  content: Scalars['String']['output'];
  contentIsTruncated: Scalars['Boolean']['output'];
};

export type GConversationAttachment = {
  __typename?: 'ConversationAttachment';
  contentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  previewUrl: Scalars['String']['output'];
  size: Scalars['Long']['output'];
};

export enum GConversationBotAssistantModeItem {
  CreateReply = 'CREATE_REPLY',
  Disconnected = 'DISCONNECTED',
  SuggestReply = 'SUGGEST_REPLY'
}

export type GConversationBotMessage = {
  __typename?: 'ConversationBotMessage';
  content: Scalars['String']['output'];
};

export enum GConversationChannelItem {
  Email = 'EMAIL',
  EmbeddedChat = 'EMBEDDED_CHAT',
  FacebookMessenger = 'FACEBOOK_MESSENGER',
  Sms = 'SMS',
  Unknown = 'UNKNOWN',
  VoiceCall = 'VOICE_CALL',
  WhatsApp = 'WHATS_APP'
}

export type GConversationContactMessage = {
  __typename?: 'ConversationContactMessage';
  attachments: Array<GConversationAttachment>;
  content: Scalars['String']['output'];
  contentIsTruncated: Scalars['Boolean']['output'];
};

export type GConversationEntity = {
  __typename?: 'ConversationEntity';
  botAssistantMode: GConversationBotAssistantModeItem;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastMessageContent?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type GConversationEvent = {
  __typename?: 'ConversationEvent';
  eventType: GAppEventType;
  metadata?: Maybe<GConversationEventMetaData>;
};

export type GConversationEventMetaData = GConversationTransferredMetaData;

export type GConversationNotFoundError = GUserError & {
  __typename?: 'ConversationNotFoundError';
  code: GUserErrorCode;
  message: Scalars['String']['output'];
};

export type GConversationTimelineData = GConversationAgentMessage | GConversationBotMessage | GConversationContactMessage | GConversationEvent;

export type GConversationTimelineEntity = {
  __typename?: 'ConversationTimelineEntity';
  conversation: Scalars['String']['output'];
  data: GConversationTimelineData;
  id: Scalars['String']['output'];
  position: Scalars['Decimal']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type GConversationTransferredMetaData = {
  __typename?: 'ConversationTransferredMetaData';
  fromChannel: GConversationChannelItem;
  fromContactAddress?: Maybe<GContactAddressEntity>;
  toChannel: GConversationChannelItem;
  toContactAddress?: Maybe<GContactAddressEntity>;
};

export type GCreateConversationContactInput = {
  byProperties?: InputMaybe<Array<GPreChatSurveyDataInput>>;
  byToken?: InputMaybe<Scalars['String']['input']>;
};

export type GCreateConversationContactMessageAttachmentInput = {
  blobName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  size: Scalars['Long']['input'];
};

export type GCreateConversationContactMessageError = GConversationNotFoundError;

export type GCreateConversationContactMessageInput = {
  attachment?: InputMaybe<GCreateConversationContactMessageAttachmentInput>;
  contact: Scalars['String']['input'];
  content: Scalars['String']['input'];
  conversation: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type GCreateConversationContactMessagePayload = {
  __typename?: 'CreateConversationContactMessagePayload';
  attachments?: Maybe<Array<GConversationAttachment>>;
  botAssistant?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<GCreateConversationContactMessageError>>;
  noAgentAvailable?: Maybe<Scalars['Boolean']['output']>;
  timeline?: Maybe<GConversationTimelineEntity>;
};

export type GCreateConversationError = GConnectedServiceNotFoundError | GContactNotFoundError;

export type GCreateConversationInput = {
  connectedService: Scalars['String']['input'];
  contact: GCreateConversationContactInput;
  content: Scalars['String']['input'];
  conversationSurveyData?: InputMaybe<Array<GPreChatSurveyDataInput>>;
  tenant: Scalars['String']['input'];
};

export type GCreateConversationPayload = {
  __typename?: 'CreateConversationPayload';
  botAssistant?: Maybe<Scalars['Boolean']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<GCreateConversationError>>;
  noAgentAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export enum GError {
  TenantSuspended = 'TENANT_SUSPENDED',
  WidgetDeleted = 'WIDGET_DELETED',
  WidgetNotFound = 'WIDGET_NOT_FOUND'
}

export type GGetWidgetConfigurationPayload = {
  __typename?: 'GetWidgetConfigurationPayload';
  configuration?: Maybe<GConnectedServiceChatEntity>;
  error?: Maybe<GError>;
};

export enum GLocaleItem {
  English = 'ENGLISH',
  Norwegian = 'NORWEGIAN'
}

export type GMutation = {
  __typename?: 'Mutation';
  contactStoppedTypingInConversation: GContactStoppedTypingInConversationPayload;
  contactTypingInConversation: GContactTypingInConversationPayload;
  createConversation: GCreateConversationPayload;
  createConversationContactMessage: GCreateConversationContactMessagePayload;
  transferConversation: GTransferConversationPayload;
};


export type GMutationContactStoppedTypingInConversationArgs = {
  input: GContactStoppedTypingInConversationInput;
};


export type GMutationContactTypingInConversationArgs = {
  input: GContactTypingInConversationInput;
};


export type GMutationCreateConversationArgs = {
  input: GCreateConversationInput;
};


export type GMutationCreateConversationContactMessageArgs = {
  input: GCreateConversationContactMessageInput;
};


export type GMutationTransferConversationArgs = {
  input: GTransferConversationInput;
};

export enum GNameVariationItem {
  FirstNameAndLastNameInitial = 'FIRST_NAME_AND_LAST_NAME_INITIAL',
  FirstNameOnly = 'FIRST_NAME_ONLY',
  FullName = 'FULL_NAME',
  InitialsOnly = 'INITIALS_ONLY',
  LastNameOnly = 'LAST_NAME_ONLY'
}

export type GPreChatSurveyDataInput = {
  fieldId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  type: GChatPreChatSurveyFieldType;
  value?: InputMaybe<Scalars['Any']['input']>;
};

export type GQuery = {
  __typename?: 'Query';
  connectedServices: Array<GConversationChannelItem>;
  conversationMessagesById: Array<GConversationTimelineEntity>;
  conversations: Array<GConversationEntity>;
  widgetConfiguration: GGetWidgetConfigurationPayload;
};


export type GQueryConnectedServicesArgs = {
  tenant: Scalars['String']['input'];
};


export type GQueryConversationMessagesByIdArgs = {
  contact: Scalars['String']['input'];
  conversation: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};


export type GQueryConversationsArgs = {
  contact: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};


export type GQueryWidgetConfigurationArgs = {
  tenant: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};

export type GSubscription = {
  __typename?: 'Subscription';
  onWebChatConversationTimelineCreated: GConversationTimelineEntity;
};


export type GSubscriptionOnWebChatConversationTimelineCreatedArgs = {
  contact: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type GTransferConversationError = GConversationNotFoundError;

export type GTransferConversationInput = {
  address: Scalars['String']['input'];
  channel: GConversationChannelItem;
  conversation: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type GTransferConversationPayload = {
  __typename?: 'TransferConversationPayload';
  conversationTimeline?: Maybe<GConversationEntity>;
  errors?: Maybe<Array<GTransferConversationError>>;
};

export type GUserError = {
  code: GUserErrorCode;
  message: Scalars['String']['output'];
};

export enum GUserErrorCode {
  AgentAlreadyExists = 'AGENT_ALREADY_EXISTS',
  AgentIsNotAuthorizedForConversation = 'AGENT_IS_NOT_AUTHORIZED_FOR_CONVERSATION',
  AgentIsNotAuthorizedForTeam = 'AGENT_IS_NOT_AUTHORIZED_FOR_TEAM',
  AgentIsNotAuthorizedToAddAgent = 'AGENT_IS_NOT_AUTHORIZED_TO_ADD_AGENT',
  AgentIsNotAuthorizedToRemoveAgent = 'AGENT_IS_NOT_AUTHORIZED_TO_REMOVE_AGENT',
  AgentNotificationNotFound = 'AGENT_NOTIFICATION_NOT_FOUND',
  AgentNotAuthorized = 'AGENT_NOT_AUTHORIZED',
  AgentNotFound = 'AGENT_NOT_FOUND',
  AssistantError = 'ASSISTANT_ERROR',
  ChatChannelNotFound = 'CHAT_CHANNEL_NOT_FOUND',
  ConnectedServiceNotFound = 'CONNECTED_SERVICE_NOT_FOUND',
  ContactAddressConflict = 'CONTACT_ADDRESS_CONFLICT',
  ContactAddressNotFound = 'CONTACT_ADDRESS_NOT_FOUND',
  ContactNotFound = 'CONTACT_NOT_FOUND',
  ConversationBotAssistantReActNotFound = 'CONVERSATION_BOT_ASSISTANT_RE_ACT_NOT_FOUND',
  ConversationHasNoConnectedService = 'CONVERSATION_HAS_NO_CONNECTED_SERVICE',
  ConversationNotFound = 'CONVERSATION_NOT_FOUND',
  ConversationSnippetNotFound = 'CONVERSATION_SNIPPET_NOT_FOUND',
  ConversationTimelineIsNotABotMessage = 'CONVERSATION_TIMELINE_IS_NOT_A_BOT_MESSAGE',
  ConversationTimelineIsNotABotSuggestion = 'CONVERSATION_TIMELINE_IS_NOT_A_BOT_SUGGESTION',
  ConversationTimelineNotFound = 'CONVERSATION_TIMELINE_NOT_FOUND',
  EmailChannelAlreadyExists = 'EMAIL_CHANNEL_ALREADY_EXISTS',
  Error = 'ERROR',
  InvalidLanguageCode = 'INVALID_LANGUAGE_CODE',
  KnowledgeBaseArticleIsPublishing = 'KNOWLEDGE_BASE_ARTICLE_IS_PUBLISHING',
  KnowledgeBaseArticleNotFound = 'KNOWLEDGE_BASE_ARTICLE_NOT_FOUND',
  MissingParameter = 'MISSING_PARAMETER',
  NoAgentsAvailableForChat = 'NO_AGENTS_AVAILABLE_FOR_CHAT',
  OnlyAdminCanModifyChannel = 'ONLY_ADMIN_CAN_MODIFY_CHANNEL',
  SmsChannelAlreadyExists = 'SMS_CHANNEL_ALREADY_EXISTS',
  TeamAlreadyExists = 'TEAM_ALREADY_EXISTS',
  TeamNotFound = 'TEAM_NOT_FOUND',
  TenantAlreadyExists = 'TENANT_ALREADY_EXISTS',
  TenantIsNotAuthorizedForTeam = 'TENANT_IS_NOT_AUTHORIZED_FOR_TEAM',
  TenantNotFound = 'TENANT_NOT_FOUND'
}

export type GWebChatAgentStoppedTyping = {
  __typename?: 'WebChatAgentStoppedTyping';
  agent?: Maybe<GAgentEntity>;
};

export type GWebChatAgentTyping = {
  __typename?: 'WebChatAgentTyping';
  agent?: Maybe<GAgentEntity>;
};

export type GWebChatBotIsProcessing = {
  __typename?: 'WebChatBotIsProcessing';
  conversationId: Scalars['String']['output'];
};

export type GWebChatConversationMessage = {
  __typename?: 'WebChatConversationMessage';
  agent?: Maybe<GAgentEntity>;
  content: Scalars['String']['output'];
  createdBy: GWebChatConversationMessageCreatedByItem;
};

export enum GWebChatConversationMessageCreatedByItem {
  Agent = 'AGENT',
  Bot = 'BOT'
}

export type GWidgetConfigurationBehaviour = {
  __typename?: 'WidgetConfigurationBehaviour';
  conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem;
  operationMode: GConnectedServiceChatEntityOperationModeItem;
};

export type GWidgetConfigurationConversation = {
  __typename?: 'WidgetConfigurationConversation';
  agentNameVariation: GNameVariationItem;
  showAgentAvatar: Scalars['Boolean']['output'];
  showAgentName: Scalars['Boolean']['output'];
};

export type GWidgetConfigurationIframe = {
  __typename?: 'WidgetConfigurationIframe';
  borderRadius: Scalars['String']['output'];
  bottomOffset: Scalars['String']['output'];
  boxShadow: Scalars['String']['output'];
  height: Scalars['String']['output'];
  rightOffset: Scalars['String']['output'];
  width: Scalars['String']['output'];
};

export type GWidgetConfigurationPreChatSurveyField = {
  __typename?: 'WidgetConfigurationPreChatSurveyField';
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  targetEntity: GChatPreChatSurveyFieldTargetEntityType;
  type: GChatPreChatSurveyFieldType;
};

export type GWidgetConfigurationText = {
  __typename?: 'WidgetConfigurationText';
  noAgentsOnlineMessage?: Maybe<Scalars['String']['output']>;
  preChatSurveyHeader?: Maybe<Scalars['String']['output']>;
  preChatSurveySubHeader?: Maybe<Scalars['String']['output']>;
  splashHeaderText?: Maybe<Scalars['String']['output']>;
  splashSubHeaderText?: Maybe<Scalars['String']['output']>;
  startMessage?: Maybe<Scalars['String']['output']>;
};

export type GWidgetConfigurationTheme = {
  __typename?: 'WidgetConfigurationTheme';
  agentBubbleBackgroundColor: Scalars['String']['output'];
  agentBubbleTextColor: Scalars['String']['output'];
  appBackgroundColorFrom: Scalars['String']['output'];
  appBackgroundColorTo: Scalars['String']['output'];
  botBubbleBackgroundColor: Scalars['String']['output'];
  botBubbleTextColor: Scalars['String']['output'];
  buttonBackgroundColor: Scalars['String']['output'];
  buttonBorderColor: Scalars['String']['output'];
  buttonTextColor: Scalars['String']['output'];
  contactBubbleBackgroundColor: Scalars['String']['output'];
  contactBubbleTextColor: Scalars['String']['output'];
  iconTextColor: Scalars['String']['output'];
  inputBackgroundColor: Scalars['String']['output'];
  inputBorderColor: Scalars['String']['output'];
  inputTextColor: Scalars['String']['output'];
  minimizedIconBackgroundColor: Scalars['String']['output'];
  minimizedIconColor: Scalars['String']['output'];
  primaryHoverColor: Scalars['String']['output'];
  primaryTextColor: Scalars['String']['output'];
  processingBubbleBackgroundColor: Scalars['String']['output'];
  processingBubbleTextColor: Scalars['String']['output'];
  topBackgroundColor: Scalars['String']['output'];
  topTextColor: Scalars['String']['output'];
};

type GConversationTimelineData_ConversationAgentMessage_Fragment = { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', firstName: string, lastName: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', contentType: string, filename: string, size: any, previewUrl: string, downloadUrl: string }> };

type GConversationTimelineData_ConversationBotMessage_Fragment = { __typename: 'ConversationBotMessage', content: string };

type GConversationTimelineData_ConversationContactMessage_Fragment = { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, attachments: Array<{ __typename?: 'ConversationAttachment', contentType: string, filename: string, size: any, previewUrl: string, downloadUrl: string }> };

type GConversationTimelineData_ConversationEvent_Fragment = { __typename: 'ConversationEvent', eventType: GAppEventType, metadata?: { __typename: 'ConversationTransferredMetaData', toChannel: GConversationChannelItem, fromChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', address: string } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', address: string } | null } | null };

export type GConversationTimelineDataFragment = GConversationTimelineData_ConversationAgentMessage_Fragment | GConversationTimelineData_ConversationBotMessage_Fragment | GConversationTimelineData_ConversationContactMessage_Fragment | GConversationTimelineData_ConversationEvent_Fragment;

export type GGetConversationMessagesQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  conversation: Scalars['String']['input'];
  contact: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  includeAgent: Scalars['Boolean']['input'];
}>;


export type GGetConversationMessagesQuery = { __typename?: 'Query', conversationMessagesById: Array<{ __typename?: 'ConversationTimelineEntity', id: string, timestamp: any, data: { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', firstName: string, lastName: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', contentType: string, filename: string, size: any, previewUrl: string, downloadUrl: string }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, attachments: Array<{ __typename?: 'ConversationAttachment', contentType: string, filename: string, size: any, previewUrl: string, downloadUrl: string }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, metadata?: { __typename: 'ConversationTransferredMetaData', toChannel: GConversationChannelItem, fromChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', address: string } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', address: string } | null } | null } }> };

export type GGetConversationChannelsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;


export type GGetConversationChannelsQuery = { __typename?: 'Query', connectedServices: Array<GConversationChannelItem> };

export type GCreateConversationMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  content: Scalars['String']['input'];
  connectedService: Scalars['String']['input'];
  contact: GCreateConversationContactInput;
  conversationSurveyData?: InputMaybe<Array<GPreChatSurveyDataInput> | GPreChatSurveyDataInput>;
}>;


export type GCreateConversationMutation = { __typename?: 'Mutation', createConversation: { __typename?: 'CreateConversationPayload', conversation?: string | null, contact?: string | null, noAgentAvailable?: boolean | null, botAssistant?: boolean | null, errors?: Array<{ __typename?: 'ConnectedServiceNotFoundError', code: GUserErrorCode, message: string } | { __typename?: 'ContactNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GTransferConversationMutationVariables = Exact<{
  input: GTransferConversationInput;
}>;


export type GTransferConversationMutation = { __typename?: 'Mutation', transferConversation: { __typename?: 'TransferConversationPayload', errors?: Array<{ __typename?: 'ConversationNotFoundError', code: GUserErrorCode, message: string }> | null } };

export type GContactIsTypingInConversationMutationVariables = Exact<{
  input: GContactTypingInConversationInput;
}>;


export type GContactIsTypingInConversationMutation = { __typename?: 'Mutation', contactTypingInConversation: { __typename?: 'ContactTypingInConversationPayload', success: boolean } };

export type GContactStoppedTypingInConversationMutationVariables = Exact<{
  input: GContactStoppedTypingInConversationInput;
}>;


export type GContactStoppedTypingInConversationMutation = { __typename?: 'Mutation', contactStoppedTypingInConversation: { __typename?: 'ContactStoppedTypingInConversationPayload', success: boolean } };

export type GCreateConversationContactMessageMutationVariables = Exact<{
  conversation: Scalars['String']['input'];
  content: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  contact: Scalars['String']['input'];
  attachment?: InputMaybe<GCreateConversationContactMessageAttachmentInput>;
}>;


export type GCreateConversationContactMessageMutation = { __typename?: 'Mutation', createConversationContactMessage: { __typename?: 'CreateConversationContactMessagePayload', botAssistant?: boolean | null, noAgentAvailable?: boolean | null, timeline?: { __typename?: 'ConversationTimelineEntity', id: string, data: { __typename?: 'ConversationAgentMessage' } | { __typename?: 'ConversationBotMessage' } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, attachments: Array<{ __typename?: 'ConversationAttachment', contentType: string, filename: string, size: any, previewUrl: string, downloadUrl: string }> } | { __typename?: 'ConversationEvent' } } | null } };

export type GOnWebChatConversationTimelineCreatedSubscriptionVariables = Exact<{
  tenant: Scalars['String']['input'];
  contact: Scalars['String']['input'];
  includeAgent: Scalars['Boolean']['input'];
}>;


export type GOnWebChatConversationTimelineCreatedSubscription = { __typename?: 'Subscription', onWebChatConversationTimelineCreated: { __typename?: 'ConversationTimelineEntity', id: string, timestamp: any, conversation: string, data: { __typename: 'ConversationAgentMessage', content: string, contentIsTruncated: boolean, agent?: { __typename?: 'AgentEntity', firstName: string, lastName: string } | null, attachments: Array<{ __typename?: 'ConversationAttachment', contentType: string, filename: string, size: any, previewUrl: string, downloadUrl: string }> } | { __typename: 'ConversationBotMessage', content: string } | { __typename: 'ConversationContactMessage', content: string, contentIsTruncated: boolean, attachments: Array<{ __typename?: 'ConversationAttachment', contentType: string, filename: string, size: any, previewUrl: string, downloadUrl: string }> } | { __typename: 'ConversationEvent', eventType: GAppEventType, metadata?: { __typename: 'ConversationTransferredMetaData', toChannel: GConversationChannelItem, fromChannel: GConversationChannelItem, fromContactAddress?: { __typename?: 'ContactAddressEntity', address: string } | null, toContactAddress?: { __typename?: 'ContactAddressEntity', address: string } | null } | null } } };

export type GGetWidgetConfigurationQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
}>;


export type GGetWidgetConfigurationQuery = { __typename?: 'Query', widgetConfiguration: { __typename?: 'GetWidgetConfigurationPayload', error?: GError | null, configuration?: { __typename?: 'ConnectedServiceChatEntity', locale: GLocaleItem, theme: { __typename?: 'WidgetConfigurationTheme', appBackgroundColorFrom: string, inputBorderColor: string, minimizedIconBackgroundColor: string, minimizedIconColor: string, topBackgroundColor: string, topTextColor: string, agentBubbleBackgroundColor: string, agentBubbleTextColor: string, botBubbleBackgroundColor: string, botBubbleTextColor: string, contactBubbleBackgroundColor: string, appBackgroundColorTo: string, contactBubbleTextColor: string, processingBubbleBackgroundColor: string, processingBubbleTextColor: string, primaryTextColor: string, primaryHoverColor: string, buttonBackgroundColor: string, buttonTextColor: string, buttonBorderColor: string, iconTextColor: string, inputBackgroundColor: string, inputTextColor: string }, behaviour: { __typename?: 'WidgetConfigurationBehaviour', operationMode: GConnectedServiceChatEntityOperationModeItem, conversationStartMode: GConnectedServiceChatEntityConversationStartModeItem }, text: { __typename?: 'WidgetConfigurationText', preChatSurveyHeader?: string | null, preChatSurveySubHeader?: string | null, startMessage?: string | null, noAgentsOnlineMessage?: string | null, splashHeaderText?: string | null, splashSubHeaderText?: string | null }, conversationSettings: { __typename?: 'WidgetConfigurationConversation', showAgentAvatar: boolean, showAgentName: boolean, agentNameVariation: GNameVariationItem }, iframeSettings: { __typename?: 'WidgetConfigurationIframe', width: string, height: string, rightOffset: string, bottomOffset: string, boxShadow: string, borderRadius: string }, preChatSurveyFields?: Array<{ __typename?: 'WidgetConfigurationPreChatSurveyField', type: GChatPreChatSurveyFieldType, id: string, label: string, placeholder?: string | null, hint?: string | null, required: boolean, options?: Array<string> | null, targetEntity: GChatPreChatSurveyFieldTargetEntityType }> | null } | null } };

export type GGetConversationsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  contact: Scalars['String']['input'];
  take: Scalars['Int']['input'];
}>;


export type GGetConversationsQuery = { __typename?: 'Query', conversations: Array<{ __typename?: 'ConversationEntity', id: string, description?: string | null, lastMessageContent?: string | null, botAssistantMode: GConversationBotAssistantModeItem, updated: any }> };

export const ConversationTimelineDataFragmentDoc = gql`
    fragment conversationTimelineData on ConversationTimelineData {
  __typename
  ... on ConversationAgentMessage {
    __typename
    content
    contentIsTruncated
    agent @include(if: $includeAgent) {
      firstName
      lastName
    }
    attachments {
      contentType
      filename
      size
      previewUrl
      downloadUrl
    }
  }
  ... on ConversationContactMessage {
    __typename
    content
    contentIsTruncated
    attachments {
      contentType
      filename
      size
      previewUrl
      downloadUrl
    }
  }
  ... on ConversationBotMessage {
    __typename
    content
  }
  ... on ConversationEvent {
    __typename
    eventType
    metadata {
      __typename
      ... on ConversationTransferredMetaData {
        toChannel
        fromChannel
        fromContactAddress {
          address
        }
        toContactAddress {
          address
        }
      }
    }
  }
}
    `;
export const GetConversationMessagesDocument = gql`
    query GetConversationMessages($tenant: String!, $conversation: String!, $contact: String!, $take: Int!, $includeAgent: Boolean!) {
  conversationMessagesById(
    tenant: $tenant
    conversation: $conversation
    contact: $contact
    take: $take
  ) {
    id
    timestamp
    data {
      ...conversationTimelineData
    }
  }
}
    ${ConversationTimelineDataFragmentDoc}`;
export const GetConversationChannelsDocument = gql`
    query GetConversationChannels($tenant: String!) {
  connectedServices(tenant: $tenant)
}
    `;
export const CreateConversationDocument = gql`
    mutation CreateConversation($tenant: String!, $content: String!, $connectedService: String!, $contact: CreateConversationContactInput!, $conversationSurveyData: [PreChatSurveyDataInput!]) {
  createConversation(
    input: {tenant: $tenant, connectedService: $connectedService, contact: $contact, content: $content, conversationSurveyData: $conversationSurveyData}
  ) {
    conversation
    contact
    noAgentAvailable
    botAssistant
    errors {
      ... on UserError {
        code
        message
      }
    }
  }
}
    `;
export const TransferConversationDocument = gql`
    mutation TransferConversation($input: TransferConversationInput!) {
  transferConversation(input: $input) {
    errors {
      ... on UserError {
        code
        message
      }
    }
  }
}
    `;
export const ContactIsTypingInConversationDocument = gql`
    mutation ContactIsTypingInConversation($input: ContactTypingInConversationInput!) {
  contactTypingInConversation(input: $input) {
    success
  }
}
    `;
export const ContactStoppedTypingInConversationDocument = gql`
    mutation ContactStoppedTypingInConversation($input: ContactStoppedTypingInConversationInput!) {
  contactStoppedTypingInConversation(input: $input) {
    success
  }
}
    `;
export const CreateConversationContactMessageDocument = gql`
    mutation CreateConversationContactMessage($conversation: String!, $content: String!, $tenant: String!, $contact: String!, $attachment: CreateConversationContactMessageAttachmentInput) {
  createConversationContactMessage(
    input: {tenant: $tenant, conversation: $conversation, content: $content, contact: $contact, attachment: $attachment}
  ) {
    timeline {
      id
      data {
        ... on ConversationContactMessage {
          __typename
          content
          contentIsTruncated
          attachments {
            contentType
            filename
            size
            previewUrl
            downloadUrl
          }
        }
      }
    }
    botAssistant
    noAgentAvailable
  }
}
    `;
export const OnWebChatConversationTimelineCreatedDocument = gql`
    subscription onWebChatConversationTimelineCreated($tenant: String!, $contact: String!, $includeAgent: Boolean!) {
  onWebChatConversationTimelineCreated(tenant: $tenant, contact: $contact) {
    id
    timestamp
    conversation
    data {
      ...conversationTimelineData
    }
  }
}
    ${ConversationTimelineDataFragmentDoc}`;
export const GetWidgetConfigurationDocument = gql`
    query GetWidgetConfiguration($tenant: String!, $widgetId: String!) {
  widgetConfiguration(tenant: $tenant, widgetId: $widgetId) {
    configuration {
      locale
      theme {
        appBackgroundColorFrom
        inputBorderColor
        minimizedIconBackgroundColor
        minimizedIconColor
        topBackgroundColor
        topTextColor
        agentBubbleBackgroundColor
        agentBubbleTextColor
        botBubbleBackgroundColor
        botBubbleTextColor
        contactBubbleBackgroundColor
        appBackgroundColorTo
        contactBubbleTextColor
        processingBubbleBackgroundColor
        processingBubbleTextColor
        primaryTextColor
        primaryHoverColor
        buttonBackgroundColor
        buttonTextColor
        buttonBorderColor
        iconTextColor
        inputBackgroundColor
        inputTextColor
      }
      behaviour {
        operationMode
        conversationStartMode
      }
      text {
        preChatSurveyHeader
        preChatSurveySubHeader
        startMessage
        noAgentsOnlineMessage
        splashHeaderText
        splashSubHeaderText
      }
      conversationSettings {
        showAgentAvatar
        showAgentName
        agentNameVariation
      }
      iframeSettings {
        width
        height
        rightOffset
        bottomOffset
        boxShadow
        borderRadius
      }
      preChatSurveyFields {
        type
        id
        label
        placeholder
        hint
        required
        options
        targetEntity
      }
    }
    error
  }
}
    `;
export const GetConversationsDocument = gql`
    query GetConversations($tenant: String!, $contact: String!, $take: Int!) {
  conversations(tenant: $tenant, contact: $contact, take: $take) {
    id
    description
    lastMessageContent
    botAssistantMode
    updated
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetConversationMessages(variables: GGetConversationMessagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetConversationMessagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetConversationMessagesQuery>(GetConversationMessagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConversationMessages', 'query');
    },
    GetConversationChannels(variables: GGetConversationChannelsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetConversationChannelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetConversationChannelsQuery>(GetConversationChannelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConversationChannels', 'query');
    },
    CreateConversation(variables: GCreateConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateConversationMutation>(CreateConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateConversation', 'mutation');
    },
    TransferConversation(variables: GTransferConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GTransferConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GTransferConversationMutation>(TransferConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TransferConversation', 'mutation');
    },
    ContactIsTypingInConversation(variables: GContactIsTypingInConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GContactIsTypingInConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GContactIsTypingInConversationMutation>(ContactIsTypingInConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactIsTypingInConversation', 'mutation');
    },
    ContactStoppedTypingInConversation(variables: GContactStoppedTypingInConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GContactStoppedTypingInConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GContactStoppedTypingInConversationMutation>(ContactStoppedTypingInConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactStoppedTypingInConversation', 'mutation');
    },
    CreateConversationContactMessage(variables: GCreateConversationContactMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GCreateConversationContactMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GCreateConversationContactMessageMutation>(CreateConversationContactMessageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateConversationContactMessage', 'mutation');
    },
    onWebChatConversationTimelineCreated(variables: GOnWebChatConversationTimelineCreatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GOnWebChatConversationTimelineCreatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<GOnWebChatConversationTimelineCreatedSubscription>(OnWebChatConversationTimelineCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'onWebChatConversationTimelineCreated', 'subscription');
    },
    GetWidgetConfiguration(variables: GGetWidgetConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetWidgetConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetWidgetConfigurationQuery>(GetWidgetConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetWidgetConfiguration', 'query');
    },
    GetConversations(variables: GGetConversationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GGetConversationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GGetConversationsQuery>(GetConversationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConversations', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;